type Case = 'CamelCase' | 'SnakeCase';
interface LooseObject {
  [key: string]: any;
}
function snakeToCamelCase<T extends object>(data?: LooseObject | any): T {
  if (!data || (Array.isArray(data) && !data.length)) {
    return data;
  }

  return transformObjectTo('CamelCase', data);
}

function camelToSnakeCase<T extends object>(data?: LooseObject | any): T {
  if (!data || (Array.isArray(data) && !data.length)) {
    return data;
  }

  return transformObjectTo('SnakeCase', data);
}

const SerializeTo = {
  CamelCase: snakeToCamelCase,
  SnakeCase: camelToSnakeCase,
};

function serializeKey(type: Case, key: string) {
  const underScore = '_';

  if (type === 'CamelCase') {
    return key
      .split(underScore)
      .map((word, index) => {
        if (index === 0) {
          return word;
        }
        return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
      })
      .join('');
  }

  return key
    .split(/(?=[A-Z])/)
    .map((word) => word.toLowerCase())
    .join(underScore);
}
function transformObjectTo<T extends object | object[]>(type: Case, data: LooseObject | any): T {
  const serializedObj: LooseObject = {};

  if (Array.isArray(data)) {
    return data.map((value) => SerializeTo[type](value)) as T;
  }

  // skips
  if (typeof data !== 'object') {
    return data;
  }

  Object.keys(data).forEach((key) => {
    const serializedKey = serializeKey(type, key);

    if (Array.isArray(data[key]) && typeof data[key][0] === 'object') {
      serializedObj[serializedKey] = data[key].map(SerializeTo[type]);
    } else if (typeof data[key] === 'object') {
      serializedObj[serializedKey] = SerializeTo[type](data[key]);
    } else {
      serializedObj[serializedKey] = data[key];
    }
  });

  return serializedObj as T;
}

export {SerializeTo, serializeKey};
